export const columns = [
  {
    title: '商品图片',
    dataIndex: 'productImg',
    key: 'productImg',
    width: 150,
    scopedSlots: {
      customRender: 'productImg'
    }
  },{
    title: '商品名称',
    dataIndex: 'productName',
    key: 'productName'
  },{
    title: '商品SKU',
    dataIndex: 'productSku',
    key: 'productSku'
  },{
    title: '商品规格',
    dataIndex: 'productProp',
    key: 'productProp'
  },{
    title: '单组数量',
    dataIndex: 'unitAmount',
    key: 'unitAmount'
  }
]